<template>
  <div class="h-panel">
    <div class="h-panel-body">
      <Form ref="form" :model="form" :rules="{}" :labelWidth="150" mode="twocolumn">
        <FormItem label="编码" prop="code" required>
          <input type="text" v-model="form.code"/>
        </FormItem>
        <FormItem label="名称" prop="name" required>
          <input type="text" v-model="form.name"/>
        </FormItem>
        <FormItem label="折旧方法" prop="depreciationMethod" required>
          <Select v-model="form.depreciationMethod" :deletable="false" dict="depreciationMethods"/>
        </FormItem>
        <FormItem label="使用期限" prop="useMonth" required>
          <input type="text" v-model="form.useMonth"/>
        </FormItem>
        <FormItem label="残值率" prop="residualRate" required>
          <input type="text" v-model.number="form.residualRate"/>
        </FormItem>
        <FormItem label="固定资产科目" prop="costAccount" required>
          <FilterSelect v-model="form.costAccount" :datas="subjectList" keyName="code" showName="name"
                        @change="selectCostAccount"/>
        </FormItem>
        <FormItem label="累计折旧科目" prop="depreciationAccount" required>
          <FilterSelect v-model="form.depreciationAccount" :datas="subjectList" keyName="code" showName="name"
                        @change="selectDepreciationAccount"/>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <input type="text" v-model="form.remark"/>
        </FormItem>
      </Form>
    </div>
    <footer class="h-modal-footer h-modal-bg-color">
      <div align="center">
        <Button @click="$emit('close')">取消</Button>
        <Button color="primary" @click="submit(form.id ? 'updateType' : 'addType')" :loading="loading">
          {{ form.id ? '更新' : '保存' }}
        </Button>
      </div>
    </footer>
  </div>
</template>

<script>

import FilterSelect from "@/components/FilterSelect.vue";

export default {
  name: "AssetsTypeForm",
  components: {FilterSelect},
  props: {
    type: String,
    nextCode: String,
    entity: Object,
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        code: null,
        name: null,
        depreciationMethod: null,
        useMonth: null,
        residualRate: null,
        costAccount: "",
        costName: "",
        depreciationAccount: "",
        depreciationName: "",
      },
      currencyList: [],
      subjectList: []
    }
  },
  methods: {
    selectCostAccount(value) {
      this.form.costAccount = value.code
      this.form.costName = value.name
    },
    selectDepreciationAccount(value) {
      this.form.depreciationAccount = value.code
      this.form.depreciationName = value.name
    },
    submit(method) {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        this.$api.assets.assetsType[method](this.form).then(() => {
          this.$emit('success');
        }).finally(() => {
          this.loading = false;
        })
      }
    }
  },
  created() {
    this.$api.setting.subject.voucherSelect().then(({data}) => {
      this.subjectList = data || [];
      this.subjectList.forEach(item => {
        item.title = item.code + ' ' + item.name
      })
    })
    this.$api.setting.currency.list().then(({data}) => {
      this.currencyList = data || [];
    })
    Object.assign(this.form, this.entity);
    if (!this.entity) {
      this.form.code = this.nextCode;
    }
  }
}
</script>
